<template>
  <div id="searchWords-wrap" >
   <tool    ref="tool"  :showLevel="showLevel">
    <template slot="title">搜索下拉词推荐</template>
  </tool>
   <task    ref="task"    :code="code"></task>
  </div>
</template>

<script>
import tool from '../../components/Tool.vue'
import task from '../../components/TaskList.vue'
import { authorityMixin } from '../../utils/mixin'
import { createTuociReq } from '../../api/auth.js'
export default {
  name: 'searchWords',

  mixins: [authorityMixin],
  components: {
    tool,
    task
  },
  data () {
    return {
      showLevel:true,
      code:'getTuociReqs'
    }
  },
  watch: {
   
  },  
  methods: {
    handleSubmit(){
      let count= this.$refs.tool.count
      let keyWords =  this.$refs.tool.keyWords
       if(!(!keyWords||(keyWords&&keyWords.length===0))){
      let data ={
        uid:this.loginUser.uid,
        name:`搜索下拉词推荐`,
        keywords:keyWords.split('\n'),
        level:count?Number(count):1
      }
      createTuociReq(data,{ simplify: false }).then(res=>{
      this.$message.success("任务提交成功")
      })
      }
      else{
        this.$message.error('请输入种子词,每一行一个词')
      }
    }
  },
 
}

</script>
<style lang='less'>
  #searchWords-wrap {
      display: flex;
      height: 100%;
      width: 100%;
      background-color: #fff;
  }
</style>
